"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformGeneralSettingsErrors = exports.transformGeneralSettingsResponse = void 0;

var _ramda = require("ramda");

var transformGeneralSettingsResponse = (0, _ramda.applySpec)({
  avatarUrl: (0, _ramda.prop)('image_url'),
  firstName: (0, _ramda.prop)('first_name'),
  lastName: (0, _ramda.prop)('last_name'),
  phone: (0, _ramda.prop)('phone_number'),
  role: (0, _ramda.prop)('employment'),
  funFacts: (0, _ramda.prop)('fun_facts'),
  showFunFacts: (0, _ramda.prop)('show_fun_facts')
});
exports.transformGeneralSettingsResponse = transformGeneralSettingsResponse;
var transformGeneralSettingsErrors = (0, _ramda.applySpec)({
  avatarUrl: (0, _ramda.prop)('image'),
  firstName: (0, _ramda.prop)('first_name'),
  lastName: (0, _ramda.prop)('last_name'),
  phone: (0, _ramda.prop)('phone_number'),
  role: (0, _ramda.prop)('employment'),
  funFacts: (0, _ramda.prop)('fun_facts')
});
exports.transformGeneralSettingsErrors = transformGeneralSettingsErrors;